/* Piktogram strony naroznika ma isc za WYBOREM, nie za pierwszym renderem.

   Dlaczego osobny skrypt: przy zmianie wartosci `product-option.js` podmienia
   wylacznie tekst w `.product-option__label` (linia 11), a konfigurator robi
   to samo w swojej sciezce (`product-configurator.js`, linia 649). Rysunek
   w przycisku zostawal wiec ten, ktory Liquid wypisal przy ladowaniu strony:
   po przelaczeniu na "Lewa" napis mowil "Lewa", a piktogram nadal pokazywal
   prawa strone (zgloszenie 8.09.2026).

   Obie sciezki ustawiaja atrybut `data-value` na <product-option>, wiec
   jeden obserwator tego atrybutu obsluguje je razem - i dziala takze po
   przeladowaniu sekcji, kiedy karta produktu dostaje nowe znaczniki.

   Rysunku nie budujemy w JS: bierzemy gotowy z pozycji listy o tej samej
   wartosci. Dzieki temu ksztalt jest z definicji ten sam, co na liscie,
   i zmiana w `icon.liquid` nie wymaga ruszania tego pliku. */
(function () {
  function odswiez(option) {
    var btnIcon = option.querySelector('.product-option__dropdown-btn .product-option__side-icon');
    if (!btnIcon) return;

    var wartosc = (option.getAttribute('data-value') || '').trim();
    if (!wartosc) return;

    var zrodlo = null;
    option.querySelectorAll('ul li').forEach(function (li) {
      var input = li.querySelector('input[type="radio"]');
      if (input && input.value.trim() === wartosc) {
        zrodlo = li.querySelector('.product-option__side-icon');
      }
    });
    if (!zrodlo || zrodlo === btnIcon) return;

    if (btnIcon.dataset.side === zrodlo.dataset.side) return;
    btnIcon.dataset.side = zrodlo.dataset.side || '';
    btnIcon.innerHTML = zrodlo.innerHTML;
  }

  function przeskanuj(korzen) {
    (korzen || document).querySelectorAll('product-option').forEach(odswiez);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { przeskanuj(); });
  } else {
    przeskanuj();
  }

  new MutationObserver(function (zmiany) {
    zmiany.forEach(function (z) {
      if (z.type === 'attributes') {
        if (z.target.tagName === 'PRODUCT-OPTION') odswiez(z.target);
        return;
      }
      z.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.tagName === 'PRODUCT-OPTION') odswiez(n);
        else przeskanuj(n);
      });
    });
  }).observe(document.documentElement, {
    attributeFilter: ['data-value'],
    attributes: true,
    childList: true,
    subtree: true
  });
})();
